/* eslint-disable react-hooks/rules-of-hooks */
import { WidgetUrlBehavior } from "@xapp/stentor-chat-widget";
import { useCallback } from "react";
import { useWidgetEnv } from "../config";
import { defaultBehavior, resolveUrlPolicy } from "../utils/resolveUrlPolicy";
import { throwBadKind } from "../utils/throwBadKind";
import { VisualState } from "../store/ChatState";
import setVisualStatus from "../store/actions/setVisualStatus";
import { ChatDispatch } from "../store/actions/types";

export type OpenUrlCallback = (url: string, dispatch: ChatDispatch, visuals: VisualState, behavior?: WidgetUrlBehavior) => void;

function execute(url: string, dispatch: ChatDispatch, visuals: VisualState, behavior: WidgetUrlBehavior) {
    if (!dispatch || !visuals) {
        throw new Error(`OpenUrl: No dispatch and/or visual.`);
    }

    const type = behavior.type;

    switch (type) {
        case "newWindow":
            if (visuals.opened) {
                dispatch(setVisualStatus({
                    opened: false
                }));
            }
            window.open(url, "callout-option", `toolbar=0,status=0,width=${behavior.width || 1000},height=${behavior.height || 700}`);
            break;
        case "newTab":
            if (visuals.opened) {
                dispatch(setVisualStatus({
                    opened: false
                }));
            }
            window.open(url, "_blank");
            break;
        case "sameWindow":
            if (!visuals.opened) {
                dispatch(setVisualStatus({
                    opened: true
                }));
            }
            window.open(url, "_self");
            break;
        default:
            throwBadKind(type);
    }
}

export function useOpenUrlCallback(): OpenUrlCallback {
    const env = useWidgetEnv();

    return useCallback<OpenUrlCallback>((url, dispatch, visuals, behavior) => {
        if (!behavior) {
            behavior = env?.urls ? resolveUrlPolicy(url, env.urls) : defaultBehavior;
        }
        execute(url, dispatch, visuals, behavior);
    }, [env]);
}
